import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const OrganizationsAccountSettingsComponent = ({ selectOrganizationsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Auto Approval"
                            name="AutoApproval"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AutoApproval'
                                )
                            }}
                            type="checkbox"
                            value={selectOrganizationsSettings?.AutoApproval}
                        />
                    </div>
                }
                expandedPanel="Account Settings"
                headerTitle="Account Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Set AddressLimit"
                            name="SetAddressLimit"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'SetAddressLimit'
                                )
                            }}
                            type="checkbox"
                            value={selectOrganizationsSettings?.SetAddressLimit}
                        />
                        {selectOrganizationsSettings?.SetAddressLimit &&
                            <InputContainer
                                label="Set AddressLimit"
                                name="MaxAddressesCount"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'MaxAddressesCount'
                                    )
                                }}
                                type="number"
                                value={selectOrganizationsSettings?.MaxAddressesCount}
                            />}
                    </div>
                }
                expandedPanel="AddressBookSetting"
                headerTitle="AddressBookSetting"
            />
        </>
    )
}
export default OrganizationsAccountSettingsComponent;
